import { render, staticRenderFns } from "./UsersManagerTab.vue?vue&type=template&id=5bd5d16e"
import script from "./UsersManagerTab.vue?vue&type=script&lang=js"
export * from "./UsersManagerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports